/**
 * Centralized date formatting utilities
 * All dates are displayed in PST (America/Los_Angeles) timezone
 */

const TIMEZONE = 'America/Los_Angeles';

/**
 * Parse date string ensuring UTC handling
 */
const parseDate = (dateStr) => {
  if (!dateStr) return null;
  // Just create a Date from the string - JavaScript handles ISO strings correctly
  return new Date(dateStr);
};

/**
 * Format date as "Mon, Jan 1" (with weekday, PST)
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = parseDate(dateStr);
  return date.toLocaleDateString('en-US', { 
    weekday: 'short', 
    month: 'short', 
    day: 'numeric',
    timeZone: TIMEZONE
  });
};

/**
 * Format date with time as "Mon, Jan 1, 10:30 AM" (PST)
 */
export const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  const date = parseDate(dateStr);
  return date.toLocaleString('en-US', { 
    weekday: 'short', 
    month: 'short', 
    day: 'numeric',
    hour: 'numeric', 
    minute: '2-digit', 
    hour12: true,
    timeZone: TIMEZONE
  });
};

/**
 * Format date as "Jan 1, 2024" (no weekday, with year)
 */
export const formatDateWithYear = (dateStr) => {
  if (!dateStr) return "-";
  const date = parseDate(dateStr);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: TIMEZONE
  });
};

/**
 * Format date as "Jan 1, 2024" (simple, no weekday) - for reports
 */
export const formatDateSimple = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};
